import { initiateBrokerCallbackLogin } from 'common/auth/modalLogin';
import { reactToastify, TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';
import { BrokerConfig } from './LoginModal/types.type';
import _ from 'lodash';
import { ACTIVE_BROKERS_DOMAINS } from '../types.type';

export const getLoginModal = (selectedBrokerConfig: BrokerConfig | undefined) => {
  const { applicationDomain } = window;
  // This has to be moved to a better place once we have more clarity on the domains and their respective brokers. For now, this is only for Aliceblue as it's the only broker which requires login from the landing page banner section.
  const loginSubDomain = [ACTIVE_BROKERS_DOMAINS.ALICEBLUE];

  const isMobileLogin = document.cookie.includes('from_mobile_auth');

  const isPrimaryDomain = _.isNull(_.get(applicationDomain, 'id', null));

  if (selectedBrokerConfig?.href) {
    if (!isPrimaryDomain || isMobileLogin || _.includes(loginSubDomain, selectedBrokerConfig.id)) {
      return (window.location.href = selectedBrokerConfig.href);
    }

    initiateBrokerCallbackLogin(selectedBrokerConfig.href)
      .then((res) => {
        window.location.href = res?.href;
      })
      .catch((error) => {
        console.error(error);
        reactToastify('Unauthorized, Please Login again!!', TOASTIFY_TYPES.ERROR);
      });
  }
};
